import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import ProcessSteps from '../components/ProcessSteps';
import CtaBand from '../components/CtaBand';
import SectionHead from '../components/SectionHead';
import Faq from '../components/Faq';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { services } from '../data/site';

const { FiCheck } = FiIcons;

function Services() {
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Surfaces made"
        accent="to be admired."
        text="Whatever the space, we bring the same discipline: careful design, a strong foundation and flawless finish."
        image={services[0].image}
      />
      <section className="py-24 md:py-32">
        <div className="wrap space-y-28">
          {services.map((s, i) => (
            <div key={s.slug} className="grid items-center gap-12 lg:grid-cols-2">
              <Reveal className={i % 2 ? 'lg:order-2' : ''}>
                <img src={s.image} alt={`${s.title} inspiration`} loading="lazy" className="aspect-[4/3] w-full object-cover" />
              </Reveal>
              <Reveal delay={0.1}>
                <p className="eyebrow">0{i + 1} / {s.tag}</p>
                <h2 className="h-display mt-4 text-5xl md:text-6xl">{s.title}</h2>
                <p className="mt-6 max-w-md text-sm leading-7 text-stone">{s.text}</p>
                <ul className="mt-6 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-sm font-semibold">
                      <SafeIcon icon={FiCheck} className="text-brick" /> {p}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="btn btn-dark mt-9">
                  Discuss your {s.title.split(' ')[0].toLowerCase()}
                </Link>
              </Reveal>
            </div>
          ))}
        </div>
      </section>
      <ProcessSteps />
      <section className="py-24 md:py-32">
        <div className="wrap">
          <SectionHead eyebrow="Good to know" title="Common" accent="questions." />
          <Faq />
        </div>
      </section>
      <CtaBand />
    </>
  );
}

export default Services;
